// // // // // // app/components/form-sections/PreviewSection.jsx
// // // // // "use client";

// // // // // import { useState } from "react";
// // // // // import { wordCount, charCount } from "../utils/stringUtils";
// // // // // import {
// // // // //   downloadTxt,
// // // // //   downloadDocx,
// // // // //   downloadPdf,
// // // // //   copyToClipboard,
// // // // // } from "../utils/exportUtils";

// // // // // export const PreviewSection = ({
// // // // //   letters,
// // // // //   activeTemplateId,
// // // // //   setActiveTemplateId,
// // // // //   TEMPLATE_CATALOG,
// // // // //   currentLetter,
// // // // //   currentDocx,
// // // // //   isCurrentEdited,
// // // // //   setLetterText,
// // // // //   revertActive,
// // // // //   form,
// // // // //   onSaveLetter,
// // // // //   savedAt,
// // // // // }) => {
// // // // //   const [isEditing, setIsEditing] = useState(false);
// // // // //   const [copiedAt, setCopiedAt] = useState(0);

// // // // //   const letterText = currentLetter() || "";
// // // // //   const docxBlob = currentDocx();
// // // // //   const edited = isCurrentEdited();

// // // // //   const handleDownloadTxt = () =>
// // // // //     downloadTxt(letterText, form.student, activeTemplateId);

// // // // //   const handleDownloadDocx = () =>
// // // // //     downloadDocx(docxBlob, form.student, activeTemplateId);

// // // // //   const handleDownloadPdf = () =>
// // // // //     downloadPdf(
// // // // //       letterText,
// // // // //       form.student,
// // // // //       activeTemplateId,
// // // // //       form.header_logoDataUrl,
// // // // //       form.header_logoAlign,
// // // // //       form.header_logoWidth
// // // // //     );

// // // // //   const handleCopy = async () => {
// // // // //     const success = await copyToClipboard(letterText);
// // // // //     if (success) {
// // // // //       setCopiedAt(Date.now());
// // // // //       setTimeout(() => setCopiedAt(0), 1500);
// // // // //     }
// // // // //   };

// // // // //   const words = wordCount(letterText);
// // // // //   const chars = charCount(letterText);

// // // // //   // Header helpers
// // // // //   const headerLines = [
// // // // //     form.header_line1,
// // // // //     form.header_line2,
// // // // //     form.header_line3,
// // // // //   ].filter(Boolean);

// // // // //   const logoJustify =
// // // // //     {
// // // // //       center: "justify-center",
// // // // //       right: "justify-end",
// // // // //       left: "justify-start",
// // // // //     }[form.header_logoAlign || "left"] || "justify-start";

// // // // //   const logoWidth = Math.max(
// // // // //     24,
// // // // //     Math.min(Number(form.header_logoWidth || 120), 300)
// // // // //   );

// // // // //   const showHeader = Boolean(form.header_logoDataUrl || headerLines.length);

// // // // //   return (
// // // // //     <div className="rounded-2xl border border-slate-200/70 bg-white/85 supports-[backdrop-filter]:bg-white/60 backdrop-blur p-4 sm:p-6 lg:p-8 shadow-xl ring-1 ring-slate-200/60">
// // // // //       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
// // // // //         <h2 className="text-lg font-bold text-slate-900">Preview</h2>

// // // // //         {/* Template tabs */}
// // // // //         <div className="flex flex-wrap gap-2">
// // // // //           {Object.keys(letters).map((tid) => {
// // // // //             const tpl = TEMPLATE_CATALOG.find((t) => t.id === tid);
// // // // //             const active = tid === activeTemplateId;
// // // // //             return (
// // // // //               <button
// // // // //                 key={tid}
// // // // //                 type="button"
// // // // //                 onClick={() => setActiveTemplateId(tid)}
// // // // //                 className={[
// // // // //                   "rounded-full px-3 py-1.5 text-sm border",
// // // // //                   active
// // // // //                     ? "bg-indigo-600 text-white border-indigo-600"
// // // // //                     : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50",
// // // // //                 ].join(" ")}
// // // // //               >
// // // // //                 {tpl?.label || tid}
// // // // //                 {letters[tid]?.edited ? (
// // // // //                   <span className="ml-1 text-[11px] font-semibold text-amber-700">
// // // // //                     (edited)
// // // // //                   </span>
// // // // //                 ) : null}
// // // // //               </button>
// // // // //             );
// // // // //           })}
// // // // //         </div>

// // // // //         <div className="flex flex-wrap gap-2">
// // // // //           {/* Save */}
// // // // //           {letterText && (
// // // // //             <button
// // // // //               onClick={onSaveLetter}
// // // // //               type="button"
// // // // //               className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-semibold text-emerald-700 shadow-sm hover:bg-emerald-100 focus:outline-none focus:ring-2 focus:ring-emerald-300/70"
// // // // //             >
// // // // //               {savedAt ? "Saved!" : "Save"}
// // // // //             </button>
// // // // //           )}

// // // // //           {/* Export buttons */}
// // // // //           {letterText && (
// // // // //             <>
// // // // //               <button
// // // // //                 onClick={handleDownloadTxt}
// // // // //                 type="button"
// // // // //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // // // //               >
// // // // //                 Download .txt
// // // // //               </button>
// // // // //               <button
// // // // //                 onClick={handleDownloadPdf}
// // // // //                 type="button"
// // // // //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // // // //               >
// // // // //                 Download .pdf
// // // // //               </button>
// // // // //             </>
// // // // //           )}

// // // // //           {/* .docx only if unedited and we still have the server docx */}
// // // // //           {docxBlob && !edited && (
// // // // //             <button
// // // // //               onClick={handleDownloadDocx}
// // // // //               type="button"
// // // // //               className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // // // //             >
// // // // //               Download .docx
// // // // //             </button>
// // // // //           )}
// // // // //         </div>
// // // // //       </div>

// // // // //       {/* Context badges */}
// // // // //       <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
// // // // //         {form.header_line1 && (
// // // // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // // //             Header: {form.header_line1}
// // // // //           </span>
// // // // //         )}
// // // // //         {form.college && (
// // // // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // // //             College: {form.college}
// // // // //           </span>
// // // // //         )}
// // // // //         {form.sport && (
// // // // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // // //             Sport: {form.sport}
// // // // //           </span>
// // // // //         )}
// // // // //         <span className="rounded-full bg-violet-50 border border-violet-200 text-violet-700 px-2 py-0.5">
// // // // //           Strength: {form.strength_rating}/5 ({form.rec_strength})
// // // // //         </span>
// // // // //         {form.need_reason && (
// // // // //           <span className="rounded-full bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-700 px-2 py-0.5">
// // // // //             Reason: {form.need_reason}
// // // // //           </span>
// // // // //         )}
// // // // //         {form.include_experience && form.experience && (
// // // // //           <span className="rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5">
// // // // //             Experience included
// // // // //           </span>
// // // // //         )}
// // // // //         {form.header_logoDataUrl && (
// // // // //           <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // // //             <img
// // // // //               src={form.header_logoDataUrl}
// // // // //               alt="Logo"
// // // // //               className="h-4 w-auto object-contain"
// // // // //               style={{ maxWidth: 60 }}
// // // // //             />
// // // // //             Logo
// // // // //           </span>
// // // // //         )}
// // // // //       </div>

// // // // //       {/* Editor controls */}
// // // // //       {letterText && (
// // // // //         <div className="mt-4 mb-2 flex flex-wrap items-center gap-2">
// // // // //           <button
// // // // //             type="button"
// // // // //             onClick={() => setIsEditing((v) => !v)}
// // // // //             className={[
// // // // //               "rounded-lg px-3 py-1.5 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2",
// // // // //               isEditing
// // // // //                 ? "bg-emerald-600 text-white hover:brightness-110 focus:ring-emerald-300"
// // // // //                 : "bg-indigo-600 text-white hover:brightness-110 focus:ring-indigo-300",
// // // // //             ].join(" ")}
// // // // //           >
// // // // //             {isEditing ? "Done editing" : "Edit letter"}
// // // // //           </button>

// // // // //           <button
// // // // //             type="button"
// // // // //             onClick={revertActive}
// // // // //             disabled={!edited}
// // // // //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// // // // //             title="Revert to the original AI draft for this template"
// // // // //           >
// // // // //             Revert to AI draft
// // // // //           </button>

// // // // //           <button
// // // // //             type="button"
// // // // //             onClick={handleCopy}
// // // // //             disabled={!letterText}
// // // // //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// // // // //           >
// // // // //             {copiedAt ? "Copied!" : "Copy"}
// // // // //           </button>

// // // // //           {edited && (
// // // // //             <span className="ml-1 text-xs text-amber-700">
// // // // //               Edited content detected — export updated <b>.pdf</b> or <b>.txt</b>. (.docx is hidden to prevent mismatch)
// // // // //             </span>
// // // // //           )}
// // // // //         </div>
// // // // //       )}

// // // // //       {/* Editor / Preview surface */}
// // // // //       <div className="mt-2 border border-slate-200 rounded-xl bg-white overflow-hidden min-h-[60vh]">
// // // // //         {letterText ? (
// // // // //           isEditing ? (
// // // // //             <textarea
// // // // //               value={letterText}
// // // // //               onChange={(e) => setLetterText(activeTemplateId, e.target.value)}
// // // // //               spellCheck={true}
// // // // //               className="w-full h-[60vh] resize-y p-5 sm:p-8 outline-none"
// // // // //               style={{
// // // // //                 fontFamily: '"Times New Roman", Times, serif',
// // // // //                 fontSize: "12pt",
// // // // //                 lineHeight: 1.5,
// // // // //                 whiteSpace: "pre-wrap",
// // // // //               }}
// // // // //             />
// // // // //           ) : (
// // // // //             <div className="w-full flex justify-center bg-slate-50">
// // // // //               {/* "Paper" preview */}
// // // // //               <div className="m-4 sm:m-6 md:m-8 bg-white shadow-sm ring-1 ring-slate-200 w-full max-w-[816px]">
// // // // //                 {/* Optional header */}
// // // // //                 {showHeader && (
// // // // //                   <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 border-b border-slate-200">
// // // // //                     {form.header_logoDataUrl && (
// // // // //                       <div className={`flex ${logoJustify} mb-3`}>
// // // // //                         <img
// // // // //                           src={form.header_logoDataUrl}
// // // // //                           alt="Header logo"
// // // // //                           className="h-auto object-contain"
// // // // //                           style={{ width: logoWidth }}
// // // // //                         />
// // // // //                       </div>
// // // // //                     )}
// // // // //                     {headerLines.length > 0 && (
// // // // //                       <div
// // // // //                         className={[
// // // // //                           "text-sm sm:text-base text-slate-700",
// // // // //                           form.header_logoAlign === "center"
// // // // //                             ? "text-center"
// // // // //                             : form.header_logoAlign === "right"
// // // // //                             ? "text-right"
// // // // //                             : "text-left",
// // // // //                         ].join(" ")}
// // // // //                       >
// // // // //                         {headerLines.map((line, i) => (
// // // // //                           <div key={i}>{line}</div>
// // // // //                         ))}
// // // // //                       </div>
// // // // //                     )}
// // // // //                   </div>
// // // // //                 )}

// // // // //                 {/* Body */}
// // // // //                 <article
// // // // //                   className="px-6 sm:px-8 py-6 sm:py-8 whitespace-pre-wrap text-slate-900"
// // // // //                   style={{
// // // // //                     fontFamily: '"Times New Roman", Times, serif',
// // // // //                     fontSize: "12pt",
// // // // //                     lineHeight: 1.5,
// // // // //                     minHeight: "60vh",
// // // // //                   }}
// // // // //                 >
// // // // //                   {letterText}
// // // // //                 </article>

// // // // //                 {/* Footer metrics */}
// // // // //                 <div className="px-6 sm:px-8 py-3 bg-slate-50 border-t border-slate-200 text-xs text-slate-600 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
// // // // //                   <div className="flex flex-wrap items-center gap-3">
// // // // //                     <span>
// // // // //                       Words: <b>{words}</b>
// // // // //                     </span>
// // // // //                     <span>
// // // // //                       Characters: <b>{chars}</b>
// // // // //                     </span>
// // // // //                   </div>
// // // // //                   {typeof savedAt === "number" && savedAt > 0 && (
// // // // //                     <span className="opacity-80">
// // // // //                       Last saved:{" "}
// // // // //                       {new Date(savedAt).toLocaleString(undefined, {
// // // // //                         year: "numeric",
// // // // //                         month: "short",
// // // // //                         day: "2-digit",
// // // // //                         hour: "2-digit",
// // // // //                         minute: "2-digit",
// // // // //                       })}
// // // // //                     </span>
// // // // //                   )}
// // // // //                 </div>
// // // // //               </div>
// // // // //             </div>
// // // // //           )
// // // // //         ) : (
// // // // //           <div className="p-10 text-center text-slate-500">
// // // // //             No letter yet. Generate a draft using the form, then edit or export it here.
// // // // //           </div>
// // // // //         )}
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default PreviewSection;



// // // // "use client";

// // // // import { useMemo, useState } from "react";
// // // // import { wordCount, charCount } from "../utils/stringUtils";
// // // // import {
// // // //   downloadTxt,
// // // //   downloadDocx,
// // // //   downloadPdf,
// // // //   copyToClipboard,
// // // // } from "../utils/exportUtils";
// // // // import LetterPreviewTemp from "./LetterPreviewTemp";

// // // // /* -------------------------------------------------------------------------- */
// // // // /* Small helpers to bind {{tokens}} for static (read-only) preview            */
// // // // /* We only escape the injected values; we assume your template's markup is OK */
// // // // /* -------------------------------------------------------------------------- */
// // // // function escapeHtml(text = "") {
// // // //   return String(text)
// // // //     .replace(/&/g, "&amp;")
// // // //     .replace(/</g, "&lt;")
// // // //     .replace(/>/g, "&gt;")
// // // //     .replace(/"/g, "&quot;");
// // // // }

// // // // function applyBindingsForPreview(rawHtml = "", form = {}) {
// // // //   const {
// // // //     experience = "",
// // // //     include_experience = true,
// // // //     signature = "",
// // // //     closing = "",
// // // //     rec_strength = "",
// // // //     strength_rating = "",
// // // //   } = form;

// // // //   const defaults = {
// // // //     experience: "—",
// // // //     signature: "Your Name",
// // // //     closing: "Sincerely,",
// // // //     rec_strength: "strongly",
// // // //     strength_rating: "5",
// // // //   };

// // // //   const map = {
// // // //     experience: include_experience ? (experience || defaults.experience) : "",
// // // //     signature: signature || defaults.signature,
// // // //     closing: closing || defaults.closing,
// // // //     rec_strength: rec_strength || defaults.rec_strength,
// // // //     strength_rating: String(strength_rating || defaults.strength_rating),
// // // //   };

// // // //   // Replace only the known tokens; leave everything else intact
// // // //   return String(rawHtml).replace(
// // // //     /{{\s*(experience|signature|closing|rec_strength|strength_rating)\s*}}/g,
// // // //     (_, key) => escapeHtml(map[key] ?? "")
// // // //   );
// // // // }

// // // // export const PreviewSection = ({
// // // //   letters,
// // // //   activeTemplateId,
// // // //   setActiveTemplateId,
// // // //   TEMPLATE_CATALOG,
// // // //   currentLetter,
// // // //   currentDocx,
// // // //   isCurrentEdited,
// // // //   setLetterText,
// // // //   revertActive,
// // // //   form,
// // // //   onSaveLetter,
// // // //   savedAt,
// // // // }) => {
// // // //   const [isEditing, setIsEditing] = useState(false);
// // // //   const [copiedAt, setCopiedAt] = useState(0);

// // // //   const letterText = currentLetter() || "";
// // // //   const docxBlob = currentDocx();
// // // //   const edited = isCurrentEdited();

// // // //   // Rendered HTML for read-only preview with {{token}} replacements
// // // //   const boundPreviewHtml = useMemo(
// // // //     () => applyBindingsForPreview(letterText, form),
// // // //     [
// // // //       letterText,
// // // //       form.experience,
// // // //       form.include_experience,
// // // //       form.signature,
// // // //       form.closing,
// // // //       form.rec_strength,
// // // //       form.strength_rating,
// // // //     ]
// // // //   );

// // // //   const handleDownloadTxt = () =>
// // // //     downloadTxt(letterText, form.student, activeTemplateId);

// // // //   const handleDownloadDocx = () =>
// // // //     downloadDocx(docxBlob, form.student, activeTemplateId);

// // // //   const handleDownloadPdf = () =>
// // // //     downloadPdf(
// // // //       letterText,
// // // //       form.student,
// // // //       activeTemplateId,
// // // //       form.header_logoDataUrl,
// // // //       form.header_logoAlign,
// // // //       form.header_logoWidth
// // // //     );

// // // //   const handleCopy = async () => {
// // // //     const success = await copyToClipboard(letterText);
// // // //     if (success) {
// // // //       setCopiedAt(Date.now());
// // // //       setTimeout(() => setCopiedAt(0), 1500);
// // // //     }
// // // //   };

// // // //   const words = wordCount(letterText);
// // // //   const chars = charCount(letterText);

// // // //   // Header helpers
// // // //   const headerLines = [form.header_line1, form.header_line2, form.header_line3].filter(Boolean);

// // // //   const logoJustify =
// // // //     {
// // // //       center: "justify-center",
// // // //       right: "justify-end",
// // // //       left: "justify-start",
// // // //     }[form.header_logoAlign || "left"] || "justify-start";

// // // //   const logoWidth = Math.max(24, Math.min(Number(form.header_logoWidth || 120), 300));
// // // //   const showHeader = Boolean(form.header_logoDataUrl || headerLines.length);

// // // //   // Bindings for TemplatePreview (live editing mode)
// // // //   const templateBindings = useMemo(
// // // //     () => ({
// // // //       experience: form.experience,
// // // //       include_experience: !!form.include_experience,
// // // //       signature: form.signature,
// // // //       closing: form.closing,
// // // //       rec_strength: form.rec_strength,
// // // //       strength_rating: String(form.strength_rating ?? ""),
// // // //     }),
// // // //     [
// // // //       form.experience,
// // // //       form.include_experience,
// // // //       form.signature,
// // // //       form.closing,
// // // //       form.rec_strength,
// // // //       form.strength_rating,
// // // //     ]
// // // //   );

// // // //   return (
// // // //     <div className="rounded-2xl border border-slate-200/70 bg-white/85 supports-[backdrop-filter]:bg-white/60 backdrop-blur p-4 sm:p-6 lg:p-8 shadow-xl ring-1 ring-slate-200/60">
// // // //       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
// // // //         <h2 className="text-lg font-bold text-slate-900">Preview</h2>

// // // //         {/* Template tabs */}
// // // //         <div className="flex flex-wrap gap-2">
// // // //           {Object.keys(letters).map((tid) => {
// // // //             const tpl = TEMPLATE_CATALOG.find((t) => t.id === tid);
// // // //             const active = tid === activeTemplateId;
// // // //             return (
// // // //               <button
// // // //                 key={tid}
// // // //                 type="button"
// // // //                 onClick={() => setActiveTemplateId(tid)}
// // // //                 className={[
// // // //                   "rounded-full px-3 py-1.5 text-sm border",
// // // //                   active
// // // //                     ? "bg-indigo-600 text-white border-indigo-600"
// // // //                     : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50",
// // // //                 ].join(" ")}
// // // //               >
// // // //                 {tpl?.label || tid}
// // // //                 {letters[tid]?.edited ? (
// // // //                   <span className="ml-1 text-[11px] font-semibold text-amber-700">
// // // //                     (edited)
// // // //                   </span>
// // // //                 ) : null}
// // // //               </button>
// // // //             );
// // // //           })}
// // // //         </div>

// // // //         <div className="flex flex-wrap gap-2">
// // // //           {/* Save */}
// // // //           {letterText && (
// // // //             <button
// // // //               onClick={onSaveLetter}
// // // //               type="button"
// // // //               className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-semibold text-emerald-700 shadow-sm hover:bg-emerald-100 focus:outline-none focus:ring-2 focus:ring-emerald-300/70"
// // // //             >
// // // //               {savedAt ? "Saved!" : "Save"}
// // // //             </button>
// // // //           )}

// // // //           {/* Export buttons */}
// // // //           {letterText && (
// // // //             <>
// // // //               <button
// // // //                 onClick={handleDownloadTxt}
// // // //                 type="button"
// // // //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // // //               >
// // // //                 Download .txt
// // // //               </button>
// // // //               <button
// // // //                 onClick={handleDownloadPdf}
// // // //                 type="button"
// // // //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // // //               >
// // // //                 Download .pdf
// // // //               </button>
// // // //             </>
// // // //           )}

// // // //           {/* .docx only if unedited and we still have the server docx */}
// // // //           {docxBlob && !edited && (
// // // //             <button
// // // //               onClick={handleDownloadDocx}
// // // //               type="button"
// // // //               className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // // //             >
// // // //               Download .docx
// // // //             </button>
// // // //           )}
// // // //         </div>
// // // //       </div>

// // // //       {/* Context badges */}
// // // //       <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
// // // //         {form.header_line1 && (
// // // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // //             Header: {form.header_line1}
// // // //           </span>
// // // //         )}
// // // //         {form.college && (
// // // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // //             College: {form.college}
// // // //           </span>
// // // //         )}
// // // //         {form.sport && (
// // // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // //             Sport: {form.sport}
// // // //           </span>
// // // //         )}
// // // //         <span className="rounded-full bg-violet-50 border border-violet-200 text-violet-700 px-2 py-0.5">
// // // //           Strength: {form.strength_rating}/5 ({form.rec_strength})
// // // //         </span>
// // // //         {form.need_reason && (
// // // //           <span className="rounded-full bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-700 px-2 py-0.5">
// // // //             Reason: {form.need_reason}
// // // //           </span>
// // // //         )}
// // // //         {form.include_experience && form.experience && (
// // // //           <span className="rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5">
// // // //             Experience included
// // // //           </span>
// // // //         )}
// // // //         {form.header_logoDataUrl && (
// // // //           <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // // //             <img
// // // //               src={form.header_logoDataUrl}
// // // //               alt="Logo"
// // // //               className="h-4 w-auto object-contain"
// // // //               style={{ maxWidth: 60 }}
// // // //             />
// // // //             Logo
// // // //           </span>
// // // //         )}
// // // //       </div>

// // // //       {/* Editor controls */}
// // // //       {letterText && (
// // // //         <div className="mt-4 mb-2 flex flex-wrap items-center gap-2">
// // // //           <button
// // // //             type="button"
// // // //             onClick={() => setIsEditing((v) => !v)}
// // // //             className={[
// // // //               "rounded-lg px-3 py-1.5 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2",
// // // //               isEditing
// // // //                 ? "bg-emerald-600 text-white hover:brightness-110 focus:ring-emerald-300"
// // // //                 : "bg-indigo-600 text-white hover:brightness-110 focus:ring-indigo-300",
// // // //             ].join(" ")}
// // // //           >
// // // //             {isEditing ? "Done editing" : "Edit letter"}
// // // //           </button>

// // // //           <button
// // // //             type="button"
// // // //             onClick={revertActive}
// // // //             disabled={!edited}
// // // //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// // // //             title="Revert to the original AI draft for this template"
// // // //           >
// // // //             Revert to AI draft
// // // //           </button>

// // // //           <button
// // // //             type="button"
// // // //             onClick={handleCopy}
// // // //             disabled={!letterText}
// // // //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// // // //           >
// // // //             {copiedAt ? "Copied!" : "Copy"}
// // // //           </button>

// // // //           {edited && (
// // // //             <span className="ml-1 text-xs text-amber-700">
// // // //               Edited content detected — export updated <b>.pdf</b> or <b>.txt</b>. (.docx is hidden to prevent mismatch)
// // // //             </span>
// // // //           )}
// // // //         </div>
// // // //       )}

// // // //       {/* Editor / Preview surface */}
// // // //       <div className="mt-2 border border-slate-200 rounded-xl bg-white overflow-hidden min-h-[60vh]">
// // // //         {letterText ? (
// // // //           <div className="w-full flex justify-center bg-slate-50">
// // // //             {/* "Paper" preview wrapper for both modes */}
// // // //             <div className="m-4 sm:m-6 md:m-8 bg-white shadow-sm ring-1 ring-slate-200 w-full max-w-[816px]">
// // // //               {/* Optional header */}
// // // //               {showHeader && (
// // // //                 <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 border-b border-slate-200">
// // // //                   {form.header_logoDataUrl && (
// // // //                     <div className={`flex ${logoJustify} mb-3`}>
// // // //                       <img
// // // //                         src={form.header_logoDataUrl}
// // // //                         alt="Header logo"
// // // //                         className="h-auto object-contain"
// // // //                         style={{ width: logoWidth }}
// // // //                       />
// // // //                     </div>
// // // //                   )}
// // // //                   {headerLines.length > 0 && (
// // // //                     <div
// // // //                       className={[
// // // //                         "text-sm sm:text-base text-slate-700",
// // // //                         form.header_logoAlign === "center"
// // // //                           ? "text-center"
// // // //                           : form.header_logoAlign === "right"
// // // //                           ? "text-right"
// // // //                           : "text-left",
// // // //                       ].join(" ")}
// // // //                     >
// // // //                       {headerLines.map((line, i) => (
// // // //                         <div key={i}>{line}</div>
// // // //                       ))}
// // // //                     </div>
// // // //                   )}
// // // //                 </div>
// // // //               )}

// // // //               {/* Body */}
// // // //               <article
// // // //                 className="px-6 sm:px-8 py-6 sm:py-8 text-slate-900"
// // // //                 style={{
// // // //                   fontFamily: '"Times New Roman", Times, serif',
// // // //                   fontSize: "12pt",
// // // //                   lineHeight: 1.5,
// // // //                   minHeight: "60vh",
// // // //                 }}
// // // //               >
// // // //                 {isEditing ? (
// // // //                   <TemplatePreview
// // // //                     html={letterText}
// // // //                     onHtmlChange={(next) => setLetterText(activeTemplateId, next)}
// // // //                     bindings={templateBindings}
// // // //                   />
// // // //                 ) : (
// // // //                   // Static, read-only HTML with bindings applied
// // // //                   <div
// // // //                     className="whitespace-pre-wrap"
// // // //                     dangerouslySetInnerHTML={{ __html: boundPreviewHtml }}
// // // //                   />
// // // //                 )}
// // // //               </article>

// // // //               {/* Footer metrics */}
// // // //               <div className="px-6 sm:px-8 py-3 bg-slate-50 border-t border-slate-200 text-xs text-slate-600 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
// // // //                 <div className="flex flex-wrap items-center gap-3">
// // // //                   <span>
// // // //                     Words: <b>{words}</b>
// // // //                   </span>
// // // //                   <span>
// // // //                     Characters: <b>{chars}</b>
// // // //                   </span>
// // // //                 </div>
// // // //                 {typeof savedAt === "number" && savedAt > 0 && (
// // // //                   <span className="opacity-80">
// // // //                     Last saved:{" "}
// // // //                     {new Date(savedAt).toLocaleString(undefined, {
// // // //                       year: "numeric",
// // // //                       month: "short",
// // // //                       day: "2-digit",
// // // //                       hour: "2-digit",
// // // //                       minute: "2-digit",
// // // //                     })}
// // // //                   </span>
// // // //                 )}
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         ) : (
// // // //           <div className="p-10 text-center text-slate-500">
// // // //             No letter yet. Generate a draft using the form, then edit or export it here.
// // // //           </div>
// // // //         )}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default PreviewSection;


// // // "use client";

// // // import { useMemo, useState } from "react";
// // // import { wordCount, charCount } from "../utils/stringUtils";
// // // import {
// // //   downloadTxt,
// // //   downloadDocx,
// // //   downloadPdf,
// // //   copyToClipboard,
// // // } from "../utils/exportUtils";
// // // import LetterPreviewTemp from "../../components/form-sections/LetterPreviewTemp";

// // // /* -------------------------------------------------------------------------- */
// // // /* Small helpers to bind {{tokens}} for static (read-only) preview            */
// // // /* -------------------------------------------------------------------------- */
// // // function escapeHtml(text = "") {
// // //   return String(text)
// // //     .replace(/&/g, "&amp;")
// // //     .replace(/</g, "&lt;")
// // //     .replace(/>/g, "&gt;")
// // //     .replace(/"/g, "&quot;");
// // // }

// // // function applyBindingsForPreview(rawHtml = "", form = {}) {
// // //   const {
// // //     experience = "",
// // //     include_experience = true,
// // //     signature = "",
// // //     closing = "",
// // //     rec_strength = "",
// // //     strength_rating = "",
// // //   } = form;

// // //   const defaults = {
// // //     experience: "—",
// // //     signature: "Your Name",
// // //     closing: "Sincerely,",
// // //     rec_strength: "strongly",
// // //     strength_rating: "5",
// // //   };

// // //   const map = {
// // //     experience: include_experience ? (experience || defaults.experience) : "",
// // //     signature: signature || defaults.signature,
// // //     closing: closing || defaults.closing,
// // //     rec_strength: rec_strength || defaults.rec_strength,
// // //     strength_rating: String(strength_rating || defaults.strength_rating),
// // //   };

// // //   return String(rawHtml).replace(
// // //     /{{\s*(experience|signature|closing|rec_strength|strength_rating)\s*}}/g,
// // //     (_, key) => escapeHtml(map[key] ?? "")
// // //   );
// // // }

// // // export const PreviewSection = ({
// // //   letters,
// // //   activeTemplateId,
// // //   setActiveTemplateId,
// // //   TEMPLATE_CATALOG,
// // //   currentLetter,
// // //   currentDocx,
// // //   isCurrentEdited,
// // //   setLetterText,
// // //   revertActive,
// // //   form,
// // //   onSaveLetter,
// // //   savedAt,
// // // }) => {
// // //   const [isEditing, setIsEditing] = useState(false);
// // //   const [copiedAt, setCopiedAt] = useState(0);

// // //   const letterText = currentLetter() || "";
// // //   const docxBlob = currentDocx();
// // //   const edited = isCurrentEdited();

// // //   const boundPreviewHtml = useMemo(
// // //     () => applyBindingsForPreview(letterText, form),
// // //     [
// // //       letterText,
// // //       form.experience,
// // //       form.include_experience,
// // //       form.signature,
// // //       form.closing,
// // //       form.rec_strength,
// // //       form.strength_rating,
// // //     ]
// // //   );

// // //   const handleDownloadTxt = () =>
// // //     downloadTxt(letterText, form.student, activeTemplateId);

// // //   const handleDownloadDocx = () =>
// // //     downloadDocx(docxBlob, form.student, activeTemplateId);

// // //   const handleDownloadPdf = () =>
// // //     downloadPdf(
// // //       letterText,
// // //       form.student,
// // //       activeTemplateId,
// // //       form.header_logoDataUrl,
// // //       form.header_logoAlign,
// // //       form.header_logoWidth
// // //     );

// // //   const handleCopy = async () => {
// // //     const success = await copyToClipboard(letterText);
// // //     if (success) {
// // //       setCopiedAt(Date.now());
// // //       setTimeout(() => setCopiedAt(0), 1500);
// // //     }
// // //   };

// // //   const words = wordCount(letterText);
// // //   const chars = charCount(letterText);

// // //   // Header helpers
// // //   const headerLines = [form.header_line1, form.header_line2, form.header_line3].filter(Boolean);

// // //   const logoJustify =
// // //     {
// // //       center: "justify-center",
// // //       right: "justify-end",
// // //       left: "justify-start",
// // //     }[form.header_logoAlign || "left"] || "justify-start";

// // //   const logoWidth = Math.max(24, Math.min(Number(form.header_logoWidth || 120), 300));
// // //   const showHeader = Boolean(form.header_logoDataUrl || headerLines.length);

// // //   // Live bindings used by TemplatePreview while editing
// // //   const templateBindings = useMemo(
// // //     () => ({
// // //       experience: form.experience,
// // //       include_experience: !!form.include_experience,
// // //       signature: form.signature,
// // //       closing: form.closing,
// // //       rec_strength: form.rec_strength,
// // //       strength_rating: String(form.strength_rating ?? ""),
// // //     }),
// // //     [
// // //       form.experience,
// // //       form.include_experience,
// // //       form.signature,
// // //       form.closing,
// // //       form.rec_strength,
// // //       form.strength_rating,
// // //     ]
// // //   );

// // //   return (
// // //     <div className="rounded-2xl border border-slate-200/70 bg-white/85 supports-[backdrop-filter]:bg-white/60 backdrop-blur p-4 sm:p-6 lg:p-8 shadow-xl ring-1 ring-slate-200/60">
// // //       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
// // //         <h2 className="text-lg font-bold text-slate-900">Preview</h2>

// // //         {/* Template tabs */}
// // //         <div className="flex flex-wrap gap-2">
// // //           {Object.keys(letters).map((tid) => {
// // //             const tpl = TEMPLATE_CATALOG.find((t) => t.id === tid);
// // //             const active = tid === activeTemplateId;
// // //             return (
// // //               <button
// // //                 key={tid}
// // //                 type="button"
// // //                 onClick={() => setActiveTemplateId(tid)}
// // //                 className={[
// // //                   "rounded-full px-3 py-1.5 text-sm border",
// // //                   active
// // //                     ? "bg-indigo-600 text-white border-indigo-600"
// // //                     : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50",
// // //                 ].join(" ")}
// // //               >
// // //                 {tpl?.label || tid}
// // //                 {letters[tid]?.edited ? (
// // //                   <span className="ml-1 text-[11px] font-semibold text-amber-700">
// // //                     (edited)
// // //                   </span>
// // //                 ) : null}
// // //               </button>
// // //             );
// // //           })}
// // //         </div>

// // //         <div className="flex flex-wrap gap-2">
// // //           {/* Save */}
// // //           {letterText && (
// // //             <button
// // //               onClick={onSaveLetter}
// // //               type="button"
// // //               className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-semibold text-emerald-700 shadow-sm hover:bg-emerald-100 focus:outline-none focus:ring-2 focus:ring-emerald-300/70"
// // //             >
// // //               {savedAt ? "Saved!" : "Save"}
// // //             </button>
// // //           )}

// // //           {/* Export buttons */}
// // //           {letterText && (
// // //             <>
// // //               <button
// // //                 onClick={handleDownloadTxt}
// // //                 type="button"
// // //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // //               >
// // //                 Download .txt
// // //               </button>
// // //               <button
// // //                 onClick={handleDownloadPdf}
// // //                 type="button"
// // //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // //               >
// // //                 Download .pdf
// // //               </button>
// // //             </>
// // //           )}

// // //           {/* .docx only if unedited and we still have the server docx */}
// // //           {docxBlob && !edited && (
// // //             <button
// // //               onClick={handleDownloadDocx}
// // //               type="button"
// // //               className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// // //             >
// // //               Download .docx
// // //             </button>
// // //           )}
// // //         </div>
// // //       </div>

// // //       {/* Context badges */}
// // //       <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
// // //         {form.header_line1 && (
// // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // //             Header: {form.header_line1}
// // //           </span>
// // //         )}
// // //         {form.college && (
// // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // //             College: {form.college}
// // //           </span>
// // //         )}
// // //         {form.sport && (
// // //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // //             Sport: {form.sport}
// // //           </span>
// // //         )}
// // //         <span className="rounded-full bg-violet-50 border border-violet-200 text-violet-700 px-2 py-0.5">
// // //           Strength: {form.strength_rating}/5 ({form.rec_strength})
// // //         </span>
// // //         {form.need_reason && (
// // //           <span className="rounded-full bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-700 px-2 py-0.5">
// // //             Reason: {form.need_reason}
// // //           </span>
// // //         )}
// // //         {form.include_experience && form.experience && (
// // //           <span className="rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5">
// // //             Experience included
// // //           </span>
// // //         )}
// // //         {form.header_logoDataUrl && (
// // //           <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// // //             <img
// // //               src={form.header_logoDataUrl}
// // //               alt="Logo"
// // //               className="h-4 w-auto object-contain"
// // //               style={{ maxWidth: 60 }}
// // //             />
// // //             Logo
// // //           </span>
// // //         )}
// // //       </div>

// // //       {/* Editor controls */}
// // //       {letterText && (
// // //         <div className="mt-4 mb-2 flex flex-wrap items-center gap-2">
// // //           <button
// // //             type="button"
// // //             onClick={() => setIsEditing((v) => !v)}
// // //             className={[
// // //               "rounded-lg px-3 py-1.5 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2",
// // //               isEditing
// // //                 ? "bg-emerald-600 text-white hover:brightness-110 focus:ring-emerald-300"
// // //                 : "bg-indigo-600 text-white hover:brightness-110 focus:ring-indigo-300",
// // //             ].join(" ")}
// // //           >
// // //             {isEditing ? "Done editing" : "Edit letter"}
// // //           </button>

// // //           <button
// // //             type="button"
// // //             onClick={revertActive}
// // //             disabled={!edited}
// // //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// // //             title="Revert to the original AI draft for this template"
// // //           >
// // //             Revert to AI draft
// // //           </button>

// // //           <button
// // //             type="button"
// // //             onClick={handleCopy}
// // //             disabled={!letterText}
// // //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// // //           >
// // //             {copiedAt ? "Copied!" : "Copy"}
// // //           </button>

// // //           {edited && (
// // //             <span className="ml-1 text-xs text-amber-700">
// // //               Edited content detected — export updated <b>.pdf</b> or <b>.txt</b>. (.docx is hidden to prevent mismatch)
// // //             </span>
// // //           )}
// // //         </div>
// // //       )}

// // //       {/* Editor / Preview surface */}
// // //       <div className="mt-2 border border-slate-200 rounded-xl bg-white overflow-hidden min-h-[60vh]">
// // //         {letterText ? (
// // //           <div className="w-full flex justify-center bg-slate-50">
// // //             {/* "Paper" preview wrapper for both modes */}
// // //             <div className="m-4 sm:m-6 md:m-8 bg-white shadow-sm ring-1 ring-slate-200 w-full max-w-[816px]">
// // //               {/* Optional header */}
// // //               {showHeader && (
// // //                 <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 border-b border-slate-200">
// // //                   {form.header_logoDataUrl && (
// // //                     <div className={`flex ${logoJustify} mb-3`}>
// // //                       <img
// // //                         src={form.header_logoDataUrl}
// // //                         alt="Header logo"
// // //                         className="h-auto object-contain"
// // //                         style={{ width: logoWidth }}
// // //                       />
// // //                     </div>
// // //                   )}
// // //                   {headerLines.length > 0 && (
// // //                     <div
// // //                       className={[
// // //                         "text-sm sm:text-base text-slate-700",
// // //                         form.header_logoAlign === "center"
// // //                           ? "text-center"
// // //                           : form.header_logoAlign === "right"
// // //                           ? "text-right"
// // //                           : "text-left",
// // //                       ].join(" ")}
// // //                     >
// // //                       {headerLines.map((line, i) => (
// // //                         <div key={i}>{line}</div>
// // //                       ))}
// // //                     </div>
// // //                   )}
// // //                 </div>
// // //               )}

// // //               {/* Body */}
// // //               <article
// // //                 className="px-6 sm:px-8 py-6 sm:py-8 text-slate-900"
// // //                 style={{
// // //                   fontFamily: '"Times New Roman", Times, serif',
// // //                   fontSize: "12pt",
// // //                   lineHeight: 1.5,
// // //                   minHeight: "60vh",
// // //                 }}
// // //               >
// // //                 {isEditing ? (
// // //                   <LetterPreviewTemp
// // //                     html={letterText}
// // //                     onHtmlChange={(next) => setLetterText(activeTemplateId, next)}
// // //                     bindings={templateBindings}
// // //                   />
// // //                 ) : (
// // //                   <div
// // //                     className="whitespace-pre-wrap"
// // //                     dangerouslySetInnerHTML={{ __html: boundPreviewHtml }}
// // //                   />
// // //                 )}
// // //               </article>

// // //               {/* Footer metrics */}
// // //               <div className="px-6 sm:px-8 py-3 bg-slate-50 border-t border-slate-200 text-xs text-slate-600 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
// // //                 <div className="flex flex-wrap items-center gap-3">
// // //                   <span>Words: <b>{words}</b></span>
// // //                   <span>Characters: <b>{chars}</b></span>
// // //                 </div>
// // //                 {typeof savedAt === "number" && savedAt > 0 && (
// // //                   <span className="opacity-80">
// // //                     Last saved:{" "}
// // //                     {new Date(savedAt).toLocaleString(undefined, {
// // //                       year: "numeric",
// // //                       month: "short",
// // //                       day: "2-digit",
// // //                       hour: "2-digit",
// // //                       minute: "2-digit",
// // //                     })}
// // //                   </span>
// // //                 )}
// // //               </div>
// // //             </div>
// // //           </div>
// // //         ) : (
// // //           <div className="p-10 text-center text-slate-500">
// // //             No letter yet. Generate a draft using the form, then edit or export it here.
// // //           </div>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default PreviewSection;


// // // app/components/form-sections/PreviewSection.jsx
// // "use client";

// // import { useMemo, useState } from "react";
// // import { wordCount, charCount } from "../utils/stringUtils";
// // import {
// //   downloadTxt,
// //   downloadDocx,
// //   downloadPdf,
// //   copyToClipboard,
// // } from "../utils/exportUtils";
// // import LetterPreviewTemp from "../../components/form-sections/LetterPreviewTemp";

// // /* -------------------------------------------------------------------------- */
// // /* Small helpers to bind {{tokens}} for static (read-only) preview            */
// // /* -------------------------------------------------------------------------- */
// // function escapeHtml(text = "") {
// //   return String(text)
// //     .replace(/&/g, "&amp;")
// //     .replace(/</g, "&lt;")
// //     .replace(/>/g, "&gt;")
// //     .replace(/"/g, "&quot;");
// // }

// // function applyBindingsForPreview(rawHtml = "", form = {}) {
// //   const {
// //     // core
// //     experience = "",
// //     include_experience = true,
// //     signature = "",
// //     closing = "",
// //     rec_strength = "",
// //     strength_rating = "",

// //     // evidence (new)
// //     achievements = "",
// //     include_achievements = true,
// //     hard_skills = "",
// //     include_hard_skills = true,
// //     soft_skills = "",
// //     include_soft_skills = true,
// //     reasons = "",
// //     include_reasons = true,
// //     story = "",
// //     include_story = true,
// //   } = form;

// //   const defaults = {
// //     experience: "—",
// //     signature: "Your Name",
// //     closing: "Sincerely,",
// //     rec_strength: "strongly",
// //     strength_rating: "5",
// //     achievements: "",
// //     hard_skills: "",
// //     soft_skills: "",
// //     reasons: "",
// //     story: "",
// //   };

// //   const map = {
// //     experience: include_experience ? (experience || defaults.experience) : "",
// //     signature: signature || defaults.signature,
// //     closing: closing || defaults.closing,
// //     rec_strength: rec_strength || defaults.rec_strength,
// //     strength_rating: String(strength_rating || defaults.strength_rating),

// //     achievements: include_achievements ? (achievements || defaults.achievements) : "",
// //     hard_skills: include_hard_skills ? (hard_skills || defaults.hard_skills) : "",
// //     soft_skills: include_soft_skills ? (soft_skills || defaults.soft_skills) : "",
// //     reasons: include_reasons ? (reasons || defaults.reasons) : "",
// //     story: include_story ? (story || defaults.story) : "",
// //   };

// //   return String(rawHtml).replace(
// //     /{{\s*(experience|signature|closing|rec_strength|strength_rating|achievements|hard_skills|soft_skills|reasons|story)\s*}}/g,
// //     (_, key) => escapeHtml(map[key] ?? "")
// //   );
// // }

// // export const PreviewSection = ({
// //   letters,
// //   activeTemplateId,
// //   setActiveTemplateId,
// //   TEMPLATE_CATALOG,
// //   currentLetter,
// //   currentDocx,
// //   isCurrentEdited,
// //   setLetterText,
// //   revertActive,
// //   form,
// //   onSaveLetter,
// //   savedAt,
// // }) => {
// //   const [isEditing, setIsEditing] = useState(false);
// //   const [copiedAt, setCopiedAt] = useState(0);

// //   const letterText = currentLetter() || "";
// //   const docxBlob = currentDocx();
// //   const edited = isCurrentEdited();

// //   const boundPreviewHtml = useMemo(
// //     () => applyBindingsForPreview(letterText, form),
// //     [
// //       letterText,
// //       // core
// //       form.experience,
// //       form.include_experience,
// //       form.signature,
// //       form.closing,
// //       form.rec_strength,
// //       form.strength_rating,
// //       // evidence
// //       form.achievements,
// //       form.include_achievements,
// //       form.hard_skills,
// //       form.include_hard_skills,
// //       form.soft_skills,
// //       form.include_soft_skills,
// //       form.reasons,
// //       form.include_reasons,
// //       form.story,
// //       form.include_story,
// //     ]
// //   );

// //   const handleDownloadTxt = () =>
// //     downloadTxt(letterText, form.student, activeTemplateId);

// //   const handleDownloadDocx = () =>
// //     downloadDocx(docxBlob, form.student, activeTemplateId);

// //   const handleDownloadPdf = () =>
// //     downloadPdf(
// //       letterText,
// //       form.student,
// //       activeTemplateId,
// //       form.header_logoDataUrl,
// //       form.header_logoAlign,
// //       form.header_logoWidth
// //     );

// //   const handleCopy = async () => {
// //     const success = await copyToClipboard(letterText);
// //     if (success) {
// //       setCopiedAt(Date.now());
// //       setTimeout(() => setCopiedAt(0), 1500);
// //     }
// //   };

// //   const words = wordCount(letterText);
// //   const chars = charCount(letterText);

// //   // Header helpers
// //   const headerLines = [form.header_line1, form.header_line2, form.header_line3].filter(Boolean);

// //   const logoJustify =
// //     {
// //       center: "justify-center",
// //       right: "justify-end",
// //       left: "justify-start",
// //     }[form.header_logoAlign || "left"] || "justify-start";

// //   const logoWidth = Math.max(24, Math.min(Number(form.header_logoWidth || 120), 300));
// //   const showHeader = Boolean(form.header_logoDataUrl || headerLines.length);

// //   // Live bindings used by the editable preview
// //   const templateBindings = useMemo(
// //     () => ({
// //       // core
// //       experience: form.experience,
// //       include_experience: !!form.include_experience,
// //       signature: form.signature,
// //       closing: form.closing,
// //       rec_strength: form.rec_strength,
// //       strength_rating: String(form.strength_rating ?? ""),
// //       // evidence
// //       achievements: form.achievements,
// //       include_achievements: !!form.include_achievements,
// //       hard_skills: form.hard_skills,
// //       include_hard_skills: !!form.include_hard_skills,
// //       soft_skills: form.soft_skills,
// //       include_soft_skills: !!form.include_soft_skills,
// //       reasons: form.reasons,
// //       include_reasons: !!form.include_reasons,
// //       story: form.story,
// //       include_story: !!form.include_story,
// //     }),
// //     [
// //       // core
// //       form.experience,
// //       form.include_experience,
// //       form.signature,
// //       form.closing,
// //       form.rec_strength,
// //       form.strength_rating,
// //       // evidence
// //       form.achievements,
// //       form.include_achievements,
// //       form.hard_skills,
// //       form.include_hard_skills,
// //       form.soft_skills,
// //       form.include_soft_skills,
// //       form.reasons,
// //       form.include_reasons,
// //       form.story,
// //       form.include_story,
// //     ]
// //   );

// //   return (
// //     <div className="rounded-2xl border border-slate-200/70 bg-white/85 supports-[backdrop-filter]:bg-white/60 backdrop-blur p-4 sm:p-6 lg:p-8 shadow-xl ring-1 ring-slate-200/60">
// //       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
// //         <h2 className="text-lg font-bold text-slate-900">Preview</h2>

// //         {/* Template tabs */}
// //         <div className="flex flex-wrap gap-2">
// //           {Object.keys(letters).map((tid) => {
// //             const tpl = TEMPLATE_CATALOG.find((t) => t.id === tid);
// //             const active = tid === activeTemplateId;
// //             return (
// //               <button
// //                 key={tid}
// //                 type="button"
// //                 onClick={() => setActiveTemplateId(tid)}
// //                 className={[
// //                   "rounded-full px-3 py-1.5 text-sm border",
// //                   active
// //                     ? "bg-indigo-600 text-white border-indigo-600"
// //                     : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50",
// //                 ].join(" ")}
// //               >
// //                 {tpl?.label || tid}
// //                 {letters[tid]?.edited ? (
// //                   <span className="ml-1 text-[11px] font-semibold text-amber-700">
// //                     (edited)
// //                   </span>
// //                 ) : null}
// //               </button>
// //             );
// //           })}
// //         </div>

// //         <div className="flex flex-wrap gap-2">
// //           {/* Save */}
// //           {letterText && (
// //             <button
// //               onClick={onSaveLetter}
// //               type="button"
// //               className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-semibold text-emerald-700 shadow-sm hover:bg-emerald-100 focus:outline-none focus:ring-2 focus:ring-emerald-300/70"
// //             >
// //               {savedAt ? "Saved!" : "Save"}
// //             </button>
// //           )}

// //           {/* Export buttons */}
// //           {letterText && (
// //             <>
// //               <button
// //                 onClick={handleDownloadTxt}
// //                 type="button"
// //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// //               >
// //                 Download .txt
// //               </button>
// //               <button
// //                 onClick={handleDownloadPdf}
// //                 type="button"
// //                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// //               >
// //                 Download .pdf
// //               </button>
// //             </>
// //           )}

// //           {/* .docx only if unedited and we still have the server docx */}
// //           {docxBlob && !edited && (
// //             <button
// //               onClick={handleDownloadDocx}
// //               type="button"
// //               className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
// //             >
// //               Download .docx
// //             </button>
// //           )}
// //         </div>
// //       </div>

// //       {/* Context badges */}
// //       <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
// //         {form.header_line1 && (
// //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// //             Header: {form.header_line1}
// //           </span>
// //         )}
// //         {form.college && (
// //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// //             College: {form.college}
// //           </span>
// //         )}
// //         {form.sport && (
// //           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// //             Sport: {form.sport}
// //           </span>
// //         )}
// //         <span className="rounded-full bg-violet-50 border border-violet-200 text-violet-700 px-2 py-0.5">
// //           Strength: {form.strength_rating}/5 ({form.rec_strength})
// //         </span>
// //         {form.need_reason && (
// //           <span className="rounded-full bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-700 px-2 py-0.5">
// //             Reason: {form.need_reason}
// //           </span>
// //         )}
// //         {form.include_experience && form.experience && (
// //           <span className="rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5">
// //             Experience included
// //           </span>
// //         )}
// //         {form.header_logoDataUrl && (
// //           <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
// //             <img
// //               src={form.header_logoDataUrl}
// //               alt="Logo"
// //               className="h-4 w-auto object-contain"
// //               style={{ maxWidth: 60 }}
// //             />
// //             Logo
// //           </span>
// //         )}
// //       </div>

// //       {/* Editor controls */}
// //       {letterText && (
// //         <div className="mt-4 mb-2 flex flex-wrap items-center gap-2">
// //           <button
// //             type="button"
// //             onClick={() => setIsEditing((v) => !v)}
// //             className={[
// //               "rounded-lg px-3 py-1.5 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2",
// //               isEditing
// //                 ? "bg-emerald-600 text-white hover:brightness-110 focus:ring-emerald-300"
// //                 : "bg-indigo-600 text-white hover:brightness-110 focus:ring-indigo-300",
// //             ].join(" ")}
// //           >
// //             {isEditing ? "Done editing" : "Edit letter"}
// //           </button>

// //           <button
// //             type="button"
// //             onClick={revertActive}
// //             disabled={!edited}
// //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// //             title="Revert to the original AI draft for this template"
// //           >
// //             Revert to AI draft
// //           </button>

// //           <button
// //             type="button"
// //             onClick={handleCopy}
// //             disabled={!letterText}
// //             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
// //           >
// //             {copiedAt ? "Copied!" : "Copy"}
// //           </button>

// //           {edited && (
// //             <span className="ml-1 text-xs text-amber-700">
// //               Edited content detected — export updated <b>.pdf</b> or <b>.txt</b>. (.docx is hidden to prevent mismatch)
// //             </span>
// //           )}
// //         </div>
// //       )}

// //       {/* Editor / Preview surface */}
// //       <div className="mt-2 border border-slate-200 rounded-xl bg-white overflow-hidden min-h-[60vh]">
// //         {letterText ? (
// //           <div className="w-full flex justify-center bg-slate-50">
// //             {/* "Paper" preview wrapper for both modes */}
// //             <div className="m-4 sm:m-6 md:m-8 bg-white shadow-sm ring-1 ring-slate-200 w-full max-w-[816px]">
// //               {/* Optional header */}
// //               {showHeader && (
// //                 <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 border-b border-slate-200">
// //                   {form.header_logoDataUrl && (
// //                     <div className={`flex ${logoJustify} mb-3`}>
// //                       <img
// //                         src={form.header_logoDataUrl}
// //                         alt="Header logo"
// //                         className="h-auto object-contain"
// //                         style={{ width: logoWidth }}
// //                       />
// //                     </div>
// //                   )}
// //                   {headerLines.length > 0 && (
// //                     <div
// //                       className={[
// //                         "text-sm sm:text-base text-slate-700",
// //                         form.header_logoAlign === "center"
// //                           ? "text-center"
// //                           : form.header_logoAlign === "right"
// //                           ? "text-right"
// //                           : "text-left",
// //                       ].join(" ")}
// //                     >
// //                       {headerLines.map((line, i) => (
// //                         <div key={i}>{line}</div>
// //                       ))}
// //                     </div>
// //                   )}
// //                 </div>
// //               )}

// //               {/* Body */}
// //               <article
// //                 className="px-6 sm:px-8 py-6 sm:py-8 text-slate-900"
// //                 style={{
// //                   fontFamily: '"Times New Roman", Times, serif',
// //                   fontSize: "12pt",
// //                   lineHeight: 1.5,
// //                   minHeight: "60vh",
// //                 }}
// //               >
// //                 {isEditing ? (
// //                   <LetterPreviewTemp
// //                     html={letterText}
// //                     onHtmlChange={(next) => setLetterText(activeTemplateId, next)}
// //                     bindings={templateBindings}
// //                   />
// //                 ) : (
// //                   <div
// //                     className="whitespace-pre-wrap"
// //                     dangerouslySetInnerHTML={{ __html: boundPreviewHtml }}
// //                   />
// //                 )}
// //               </article>

// //               {/* Footer metrics */}
// //               <div className="px-6 sm:px-8 py-3 bg-slate-50 border-t border-slate-200 text-xs text-slate-600 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
// //                 <div className="flex flex-wrap items-center gap-3">
// //                   <span>Words: <b>{words}</b></span>
// //                   <span>Characters: <b>{chars}</b></span>
// //                 </div>
// //                 {typeof savedAt === "number" && savedAt > 0 && (
// //                   <span className="opacity-80">
// //                     Last saved:{" "}
// //                     {new Date(savedAt).toLocaleString(undefined, {
// //                       year: "numeric",
// //                       month: "short",
// //                       day: "2-digit",
// //                       hour: "2-digit",
// //                       minute: "2-digit",
// //                     })}
// //                   </span>
// //                 )}
// //               </div>
// //             </div>
// //           </div>
// //         ) : (
// //           <div className="p-10 text-center text-slate-500">
// //             No letter yet. Generate a draft using the form, then edit or export it here.
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default PreviewSection;


// // app/components/form-sections/PreviewSection.jsx
// "use client";

// import { useMemo, useState } from "react";
// // Local helpers (replacing ../utils/stringUtils for this file)
// const wordCount = (t = "") => (t.trim() ? t.trim().split(/\s+/).length : 0);
// const charCount = (t = "") => String(t ?? "").length;

// import {
//   downloadTxt,
//   downloadDocx,
//   downloadPdf,
//   copyToClipboard,
// } from "../utils/exportUtils";
// // Fixed path: this file sits in the same folder as LetterPreviewTemp
// import LetterPreviewTemp from "./LetterPreviewTemp";

// /* -------------------------------------------------------------------------- */
// /* Small helpers to bind {{tokens}} for static (read-only) preview            */
// /* -------------------------------------------------------------------------- */
// function escapeHtml(text = "") {
//   return String(text)
//     .replace(/&/g, "&amp;")
//     .replace(/</g, "&lt;")
//     .replace(/>/g, "&gt;")
//     .replace(/"/g, "&quot;");
// }

// function applyBindingsForPreview(rawHtml = "", form = {}) {
//   const {
//     // core
//     experience = "",
//     include_experience = true,
//     signature = "",
//     closing = "",
//     rec_strength = "",
//     strength_rating = "",

//     // evidence (new)
//     achievements = "",
//     include_achievements = true,
//     hard_skills = "",
//     include_hard_skills = true,
//     soft_skills = "",
//     include_soft_skills = true,
//     reasons = "",
//     include_reasons = true,
//     story = "",
//     include_story = true,
//   } = form;

//   const defaults = {
//     experience: "—",
//     signature: "Your Name",
//     closing: "Sincerely,",
//     rec_strength: "strongly",
//     strength_rating: "5",
//     achievements: "",
//     hard_skills: "",
//     soft_skills: "",
//     reasons: "",
//     story: "",
//   };

//   const map = {
//     experience: include_experience ? (experience || defaults.experience) : "",
//     signature: signature || defaults.signature,
//     closing: closing || defaults.closing,
//     rec_strength: rec_strength || defaults.rec_strength,
//     strength_rating: String(strength_rating || defaults.strength_rating),

//     achievements: include_achievements ? (achievements || defaults.achievements) : "",
//     hard_skills: include_hard_skills ? (hard_skills || defaults.hard_skills) : "",
//     soft_skills: include_soft_skills ? (soft_skills || defaults.soft_skills) : "",
//     reasons: include_reasons ? (reasons || defaults.reasons) : "",
//     story: include_story ? (story || defaults.story) : "",
//   };

//   return String(rawHtml).replace(
//     /{{\s*(experience|signature|closing|rec_strength|strength_rating|achievements|hard_skills|soft_skills|reasons|story)\s*}}/g,
//     (_, key) => escapeHtml(map[key] ?? "")
//   );
// }

// export const PreviewSection = ({
//   letters,
//   activeTemplateId,
//   setActiveTemplateId,
//   TEMPLATE_CATALOG,
//   currentLetter,
//   currentDocx,
//   isCurrentEdited,
//   setLetterText,
//   revertActive,
//   form,
//   onSaveLetter,
//   savedAt,
// }) => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [copiedAt, setCopiedAt] = useState(0);

//   const letterText = currentLetter() || "";
//   const docxBlob = currentDocx();
//   const edited = isCurrentEdited();

//   const boundPreviewHtml = useMemo(
//     () => applyBindingsForPreview(letterText, form),
//     [
//       letterText,
//       // core
//       form.experience,
//       form.include_experience,
//       form.signature,
//       form.closing,
//       form.rec_strength,
//       form.strength_rating,
//       // evidence
//       form.achievements,
//       form.include_achievements,
//       form.hard_skills,
//       form.include_hard_skills,
//       form.soft_skills,
//       form.include_soft_skills,
//       form.reasons,
//       form.include_reasons,
//       form.story,
//       form.include_story,
//     ]
//   );

//   const handleDownloadTxt = () =>
//     downloadTxt(letterText, form.student, activeTemplateId);

//   const handleDownloadDocx = () =>
//     downloadDocx(docxBlob, form.student, activeTemplateId);

//   const handleDownloadPdf = () =>
//     downloadPdf(
//       letterText,
//       form.student,
//       activeTemplateId,
//       form.header_logoDataUrl,
//       form.header_logoAlign,
//       form.header_logoWidth
//     );

//   const handleCopy = async () => {
//     const success = await copyToClipboard(letterText);
//     if (success) {
//       setCopiedAt(Date.now());
//       setTimeout(() => setCopiedAt(0), 1500);
//     }
//   };

//   const words = wordCount(letterText);
//   const chars = charCount(letterText);

//   // Header helpers
//   const headerLines = [form.header_line1, form.header_line2, form.header_line3].filter(Boolean);

//   const logoJustify =
//     {
//       center: "justify-center",
//       right: "justify-end",
//       left: "justify-start",
//     }[form.header_logoAlign || "left"] || "justify-start";

//   const logoWidth = Math.max(24, Math.min(Number(form.header_logoWidth || 120), 300));
//   const showHeader = Boolean(form.header_logoDataUrl || headerLines.length);

//   // Live bindings used by the editable preview
//   const templateBindings = useMemo(
//     () => ({
//       // core
//       experience: form.experience,
//       include_experience: !!form.include_experience,
//       signature: form.signature,
//       closing: form.closing,
//       rec_strength: form.rec_strength,
//       strength_rating: String(form.strength_rating ?? ""),
//       // evidence
//       achievements: form.achievements,
//       include_achievements: !!form.include_achievements,
//       hard_skills: form.hard_skills,
//       include_hard_skills: !!form.include_hard_skills,
//       soft_skills: form.soft_skills,
//       include_soft_skills: !!form.include_soft_skills,
//       reasons: form.reasons,
//       include_reasons: !!form.include_reasons,
//       story: form.story,
//       include_story: !!form.include_story,
//     }),
//     [
//       // core
//       form.experience,
//       form.include_experience,
//       form.signature,
//       form.closing,
//       form.rec_strength,
//       form.strength_rating,
//       // evidence
//       form.achievements,
//       form.include_achievements,
//       form.hard_skills,
//       form.include_hard_skills,
//       form.soft_skills,
//       form.include_soft_skills,
//       form.reasons,
//       form.include_reasons,
//       form.story,
//       form.include_story,
//     ]
//   );

//   return (
//     <div className="rounded-2xl border border-slate-200/70 bg-white/85 supports-[backdrop-filter]:bg-white/60 backdrop-blur p-4 sm:p-6 lg:p-8 shadow-xl ring-1 ring-slate-200/60">
//       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
//         <h2 className="text-lg font-bold text-slate-900">Preview</h2>

//         {/* Template tabs */}
//         <div className="flex flex-wrap gap-2">
//           {Object.keys(letters).map((tid) => {
//             const tpl = TEMPLATE_CATALOG.find((t) => t.id === tid);
//             const active = tid === activeTemplateId;
//             return (
//               <button
//                 key={tid}
//                 type="button"
//                 onClick={() => setActiveTemplateId(tid)}
//                 className={[
//                   "rounded-full px-3 py-1.5 text-sm border",
//                   active
//                     ? "bg-indigo-600 text-white border-indigo-600"
//                     : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50",
//                 ].join(" ")}
//               >
//                 {tpl?.label || tid}
//                 {letters[tid]?.edited ? (
//                   <span className="ml-1 text-[11px] font-semibold text-amber-700">
//                     (edited)
//                   </span>
//                 ) : null}
//               </button>
//             );
//           })}
//         </div>

//         <div className="flex flex-wrap gap-2">
//           {/* Save */}
//           {letterText && (
//             <button
//               onClick={onSaveLetter}
//               type="button"
//               className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-semibold text-emerald-700 shadow-sm hover:bg-emerald-100 focus:outline-none focus:ring-2 focus:ring-emerald-300/70"
//             >
//               {savedAt ? "Saved!" : "Save"}
//             </button>
//           )}

//           {/* Export buttons */}
//           {letterText && (
//             <>
//               <button
//                 onClick={handleDownloadTxt}
//                 type="button"
//                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
//               >
//                 Download .txt
//               </button>
//               <button
//                 onClick={handleDownloadPdf}
//                 type="button"
//                 className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
//               >
//                 Download .pdf
//               </button>
//             </>
//           )}

//           {/* .docx only if unedited and we still have the server docx */}
//           {docxBlob && !edited && (
//             <button
//               onClick={handleDownloadDocx}
//               type="button"
//               className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
//             >
//               Download .docx
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Context badges */}
//       <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
//         {form.header_line1 && (
//           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
//             Header: {form.header_line1}
//           </span>
//         )}
//         {form.college && (
//           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
//             College: {form.college}
//           </span>
//         )}
//         {form.sport && (
//           <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
//             Sport: {form.sport}
//           </span>
//         )}
//         <span className="rounded-full bg-violet-50 border border-violet-200 text-violet-700 px-2 py-0.5">
//           Strength: {form.strength_rating}/5 ({form.rec_strength})
//         </span>
//         {form.need_reason && (
//           <span className="rounded-full bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-700 px-2 py-0.5">
//             Reason: {form.need_reason}
//           </span>
//         )}
//         {form.include_experience && form.experience && (
//           <span className="rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5">
//             Experience included
//           </span>
//         )}
//         {form.header_logoDataUrl && (
//           <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
//             <img
//               src={form.header_logoDataUrl}
//               alt="Logo"
//               className="h-4 w-auto object-contain"
//               style={{ maxWidth: 60 }}
//             />
//             Logo
//           </span>
//         )}
//       </div>

//       {/* Editor controls */}
//       {letterText && (
//         <div className="mt-4 mb-2 flex flex-wrap items-center gap-2">
//           <button
//             type="button"
//             onClick={() => setIsEditing((v) => !v)}
//             className={[
//               "rounded-lg px-3 py-1.5 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2",
//               isEditing
//                 ? "bg-emerald-600 text-white hover:brightness-110 focus:ring-emerald-300"
//                 : "bg-indigo-600 text-white hover:brightness-110 focus:ring-indigo-300",
//             ].join(" ")}
//           >
//             {isEditing ? "Done editing" : "Edit letter"}
//           </button>

//           <button
//             type="button"
//             onClick={revertActive}
//             disabled={!edited}
//             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
//             title="Revert to the original AI draft for this template"
//           >
//             Revert to AI draft
//           </button>

//           <button
//             type="button"
//             onClick={handleCopy}
//             disabled={!letterText}
//             className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
//           >
//             {copiedAt ? "Copied!" : "Copy"}
//           </button>

//           {edited && (
//             <span className="ml-1 text-xs text-amber-700">
//               Edited content detected — export updated <b>.pdf</b> or <b>.txt</b>. (.docx is hidden to prevent mismatch)
//             </span>
//           )}
//         </div>
//       )}

//       {/* Editor / Preview surface */}
//       <div className="mt-2 border border-slate-200 rounded-xl bg-white overflow-hidden min-h-[60vh]">
//         {letterText ? (
//           <div className="w-full flex justify-center bg-slate-50">
//             {/* "Paper" preview wrapper for both modes */}
//             <div className="m-4 sm:m-6 md:m-8 bg-white shadow-sm ring-1 ring-slate-200 w-full max-w-[816px]">
//               {/* Optional header */}
//               {showHeader && (
//                 <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 border-b border-slate-200">
//                   {form.header_logoDataUrl && (
//                     <div className={`flex ${logoJustify} mb-3`}>
//                       <img
//                         src={form.header_logoDataUrl}
//                         alt="Header logo"
//                         className="h-auto object-contain"
//                         style={{ width: logoWidth }}
//                       />
//                     </div>
//                   )}
//                   {headerLines.length > 0 && (
//                     <div
//                       className={[
//                         "text-sm sm:text-base text-slate-700",
//                         form.header_logoAlign === "center"
//                           ? "text-center"
//                           : form.header_logoAlign === "right"
//                           ? "text-right"
//                           : "text-left",
//                       ].join(" ")}
//                     >
//                       {headerLines.map((line, i) => (
//                         <div key={i}>{line}</div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Body */}
//               <article
//                 className="px-6 sm:px-8 py-6 sm:py-8 text-slate-900"
//                 style={{
//                   fontFamily: '"Times New Roman", Times, serif',
//                   fontSize: "12pt",
//                   lineHeight: 1.5,
//                   minHeight: "60vh",
//                 }}
//               >
//                 {isEditing ? (
//                   <LetterPreviewTemp
//                     html={letterText}
//                     onHtmlChange={(next) => setLetterText(activeTemplateId, next)}
//                     bindings={templateBindings}
//                   />
//                 ) : (
//                   <div
//                     className="whitespace-pre-wrap"
//                     dangerouslySetInnerHTML={{ __html: boundPreviewHtml }}
//                   />
//                 )}
//               </article>

//               {/* Footer metrics */}
//               <div className="px-6 sm:px-8 py-3 bg-slate-50 border-t border-slate-200 text-xs text-slate-600 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
//                 <div className="flex flex-wrap items-center gap-3">
//                   <span>
//                     Words: <b>{words}</b>
//                   </span>
//                   <span>
//                     Characters: <b>{chars}</b>
//                   </span>
//                 </div>
//                 {typeof savedAt === "number" && savedAt > 0 && (
//                   <span className="opacity-80">
//                     Last saved:{" "}
//                     {new Date(savedAt).toLocaleString(undefined, {
//                       year: "numeric",
//                       month: "short",
//                       day: "2-digit",
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     })}
//                   </span>
//                 )}
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="p-10 text-center text-slate-500">
//             No letter yet. Generate a draft using the form, then edit or export it here.
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PreviewSection;


// app/components/form-sections/PreviewSection.jsx
"use client";

import { useMemo, useState } from "react";
// Local helpers (replacing ../utils/stringUtils for this file)
const wordCount = (t = "") => (t.trim() ? t.trim().split(/\s+/).length : 0);
const charCount = (t = "") => String(t ?? "").length;

import {
  downloadTxt,
  downloadDocx,
  downloadPdf,
  copyToClipboard,
} from "../utils/exportUtils";
// Fixed path: this file sits in the same folder as LetterPreviewTemp
import LetterPreviewTemp from "./LetterPreviewTemp";

/* -------------------------------------------------------------------------- */
/* Small helpers to bind {{tokens}} for static (read-only) preview            */
/* -------------------------------------------------------------------------- */
function escapeHtml(text = "") {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function applyBindingsForPreview(rawHtml = "", form = {}) {
  const {
    // core
    experience = "",
    include_experience = true,
    signature = "",
    rec_strength = "",
    strength_rating = "",

    // evidence (new)
    achievements = "",
    include_achievements = true,
    hard_skills = "",
    include_hard_skills = true,
    soft_skills = "",
    include_soft_skills = true,
    reasons = "",
    include_reasons = true,
    story = "",
    include_story = true,
  } = form;

  const defaults = {
    experience: "—",
    signature: "Your Name",
    rec_strength: "strongly",
    strength_rating: "5",
    achievements: "",
    hard_skills: "",
    soft_skills: "",
    reasons: "",
    story: "",
  };

  const map = {
    experience: include_experience ? (experience || defaults.experience) : "",
    signature: signature || defaults.signature,
    rec_strength: rec_strength || defaults.rec_strength,
    strength_rating: String(strength_rating || defaults.strength_rating),

    achievements: include_achievements ? (achievements || defaults.achievements) : "",
    hard_skills: include_hard_skills ? (hard_skills || defaults.hard_skills) : "",
    soft_skills: include_soft_skills ? (soft_skills || defaults.soft_skills) : "",
    reasons: include_reasons ? (reasons || defaults.reasons) : "",
    story: include_story ? (story || defaults.story) : "",
  };

  // Replace known tokens (without closing)
  let out = String(rawHtml).replace(
    /{{\s*(experience|signature|rec_strength|strength_rating|achievements|hard_skills|soft_skills|reasons|story)\s*}}/g,
    (_, key) => escapeHtml(map[key] ?? "")
  );

  // Backward-compat: strip any legacy {{closing}} tokens if present
  out = out.replace(/{{\s*closing\s*}}/g, "");

  return out;
}

export const PreviewSection = ({
  letters,
  activeTemplateId,
  setActiveTemplateId,
  TEMPLATE_CATALOG,
  currentLetter,
  currentDocx,
  isCurrentEdited,
  setLetterText,
  revertActive,
  form,
  onSaveLetter,
  savedAt,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [copiedAt, setCopiedAt] = useState(0);

  const letterText = currentLetter() || "";
  const docxBlob = currentDocx();
  const edited = isCurrentEdited();

  const boundPreviewHtml = useMemo(
    () => applyBindingsForPreview(letterText, form),
    [
      letterText,
      // core
      form.experience,
      form.include_experience,
      form.signature,
      form.rec_strength,
      form.strength_rating,
      // evidence
      form.achievements,
      form.include_achievements,
      form.hard_skills,
      form.include_hard_skills,
      form.soft_skills,
      form.include_soft_skills,
      form.reasons,
      form.include_reasons,
      form.story,
      form.include_story,
    ]
  );

  const handleDownloadTxt = () =>
    downloadTxt(letterText, form.student, activeTemplateId);

  const handleDownloadDocx = () =>
    downloadDocx(docxBlob, form.student, activeTemplateId);

  const handleDownloadPdf = () =>
    downloadPdf(
      letterText,
      form.student,
      activeTemplateId,
      form.header_logoDataUrl,
      form.header_logoAlign,
      form.header_logoWidth
    );

  const handleCopy = async () => {
    const success = await copyToClipboard(letterText);
    if (success) {
      setCopiedAt(Date.now());
      setTimeout(() => setCopiedAt(0), 1500);
    }
  };

  const words = wordCount(letterText);
  const chars = charCount(letterText);

  // Header helpers
  const headerLines = [form.header_line1, form.header_line2, form.header_line3].filter(Boolean);

  const logoJustify =
    {
      center: "justify-center",
      right: "justify-end",
      left: "justify-start",
    }[form.header_logoAlign || "left"] || "justify-start";

  const logoWidth = Math.max(24, Math.min(Number(form.header_logoWidth || 120), 300));
  const showHeader = Boolean(form.header_logoDataUrl || headerLines.length);

  // Live bindings used by the editable preview (no closing)
  const templateBindings = useMemo(
    () => ({
      // core
      experience: form.experience,
      include_experience: !!form.include_experience,
      signature: form.signature,
      rec_strength: form.rec_strength,
      strength_rating: String(form.strength_rating ?? ""),
      // evidence
      achievements: form.achievements,
      include_achievements: !!form.include_achievements,
      hard_skills: form.hard_skills,
      include_hard_skills: !!form.include_hard_skills,
      soft_skills: form.soft_skills,
      include_soft_skills: !!form.include_soft_skills,
      reasons: form.reasons,
      include_reasons: !!form.include_reasons,
      story: form.story,
      include_story: !!form.include_story,
    }),
    [
      // core
      form.experience,
      form.include_experience,
      form.signature,
      form.rec_strength,
      form.strength_rating,
      // evidence
      form.achievements,
      form.include_achievements,
      form.hard_skills,
      form.include_hard_skills,
      form.soft_skills,
      form.include_soft_skills,
      form.reasons,
      form.include_reasons,
      form.story,
      form.include_story,
    ]
  );

  return (
    <div className="rounded-2xl border border-slate-200/70 bg-white/85 supports-[backdrop-filter]:bg-white/60 backdrop-blur p-4 sm:p-6 lg:p-8 shadow-xl ring-1 ring-slate-200/60">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <h2 className="text-lg font-bold text-slate-900">Preview</h2>

        {/* Template tabs */}
        <div className="flex flex-wrap gap-2">
          {Object.keys(letters).map((tid) => {
            const tpl = TEMPLATE_CATALOG.find((t) => t.id === tid);
            const active = tid === activeTemplateId;
            return (
              <button
                key={tid}
                type="button"
                onClick={() => setActiveTemplateId(tid)}
                className={[
                  "rounded-full px-3 py-1.5 text-sm border",
                  active
                    ? "bg-indigo-600 text-white border-indigo-600"
                    : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50",
                ].join(" ")}
              >
                {tpl?.label || tid}
                {letters[tid]?.edited ? (
                  <span className="ml-1 text-[11px] font-semibold text-amber-700">
                    (edited)
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>

        <div className="flex flex-wrap gap-2">
          {/* Save */}
          {letterText && (
            <button
              onClick={onSaveLetter}
              type="button"
              className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-semibold text-emerald-700 shadow-sm hover:bg-emerald-100 focus:outline-none focus:ring-2 focus:ring-emerald-300/70"
            >
              {savedAt ? "Saved!" : "Save"}
            </button>
          )}

          {/* Export buttons */}
          {letterText && (
            <>
              <button
                onClick={handleDownloadTxt}
                type="button"
                className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
              >
                Download .txt
              </button>
              <button
                onClick={handleDownloadPdf}
                type="button"
                className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
              >
                Download .pdf
              </button>
            </>
          )}

          {/* .docx only if unedited and we still have the server docx */}
          {docxBlob && !edited && (
            <button
              onClick={handleDownloadDocx}
              type="button"
              className="rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300/70"
            >
              Download .docx
            </button>
          )}
        </div>
      </div>

      {/* Context badges */}
      <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
        {form.header_line1 && (
          <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
            Header: {form.header_line1}
          </span>
        )}
        {form.college && (
          <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
            College: {form.college}
          </span>
        )}
        {form.sport && (
          <span className="rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
            Sport: {form.sport}
          </span>
        )}
        <span className="rounded-full bg-violet-50 border border-violet-200 text-violet-700 px-2 py-0.5">
          Strength: {form.strength_rating}/5 ({form.rec_strength})
        </span>
        {form.need_reason && (
          <span className="rounded-full bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-700 px-2 py-0.5">
            Reason: {form.need_reason}
          </span>
        )}
        {form.include_experience && form.experience && (
          <span className="rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5">
            Experience included
          </span>
        )}
        {form.header_logoDataUrl && (
          <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 px-2 py-0.5">
            <img
              src={form.header_logoDataUrl}
              alt="Logo"
              className="h-4 w-auto object-contain"
              style={{ maxWidth: 60 }}
            />
            Logo
          </span>
        )}
      </div>

      {/* Editor controls */}
      {letterText && (
        <div className="mt-4 mb-2 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => setIsEditing((v) => !v)}
            className={[
              "rounded-lg px-3 py-1.5 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2",
              isEditing
                ? "bg-emerald-600 text-white hover:brightness-110 focus:ring-emerald-300"
                : "bg-indigo-600 text-white hover:brightness-110 focus:ring-indigo-300",
            ].join(" ")}
          >
            {isEditing ? "Done editing" : "Edit letter"}
          </button>

          <button
            type="button"
            onClick={revertActive}
            disabled={!edited}
            className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
            title="Revert to the original AI draft for this template"
          >
            Revert to AI draft
          </button>

          <button
            type="button"
            onClick={handleCopy}
            disabled={!letterText}
            className="rounded-lg px-3 py-1.5 text-sm font-semibold border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-50"
          >
            {copiedAt ? "Copied!" : "Copy"}
          </button>

          {edited && (
            <span className="ml-1 text-xs text-amber-700">
              Edited content detected — export updated <b>.pdf</b> or <b>.txt</b>. (.docx is hidden to prevent mismatch)
            </span>
          )}
        </div>
      )}

      {/* Editor / Preview surface */}
      <div className="mt-2 border border-slate-200 rounded-xl bg-white overflow-hidden min-h-[60vh]">
        {letterText ? (
          <div className="w-full flex justify-center bg-slate-50">
            {/* "Paper" preview wrapper for both modes */}
            <div className="m-4 sm:m-6 md:m-8 bg-white shadow-sm ring-1 ring-slate-200 w-full max-w-[816px]">
              {/* Optional header */}
              {showHeader && (
                <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 border-b border-slate-200">
                  {form.header_logoDataUrl && (
                    <div className={`flex ${logoJustify} mb-3`}>
                      <img
                        src={form.header_logoDataUrl}
                        alt="Header logo"
                        className="h-auto object-contain"
                        style={{ width: logoWidth }}
                      />
                    </div>
                  )}
                  {headerLines.length > 0 && (
                    <div
                      className={[
                        "text-sm sm:text-base text-slate-700",
                        form.header_logoAlign === "center"
                          ? "text-center"
                          : form.header_logoAlign === "right"
                          ? "text-right"
                          : "text-left",
                      ].join(" ")}
                    >
                      {headerLines.map((line, i) => (
                        <div key={i}>{line}</div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Body */}
              <article
                className="px-6 sm:px-8 py-6 sm:py-8 text-slate-900"
                style={{
                  fontFamily: '"Times New Roman", Times, serif',
                  fontSize: "12pt",
                  lineHeight: 1.5,
                  minHeight: "60vh",
                }}
              >
                {isEditing ? (
                  <LetterPreviewTemp
                    html={letterText}
                    onHtmlChange={(next) => setLetterText(activeTemplateId, next)}
                    bindings={templateBindings}
                  />
                ) : (
                  <div
                    className="whitespace-pre-wrap"
                    dangerouslySetInnerHTML={{ __html: boundPreviewHtml }}
                  />
                )}
              </article>

              {/* Footer metrics */}
              <div className="px-6 sm:px-8 py-3 bg-slate-50 border-t border-slate-200 text-xs text-slate-600 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <div className="flex flex-wrap items-center gap-3">
                  <span>
                    Words: <b>{words}</b>
                  </span>
                  <span>
                    Characters: <b>{chars}</b>
                  </span>
                </div>
                {typeof savedAt === "number" && savedAt > 0 && (
                  <span className="opacity-80">
                    Last saved:{" "}
                    {new Date(savedAt).toLocaleString(undefined, {
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="p-10 text-center text-slate-500">
            No letter yet. Generate a draft using the form, then edit or export it here.
          </div>
        )}
      </div>
    </div>
  );
};

export default PreviewSection;
